module.exports = __webpack_public_path__ + "media/img/new-assets/user-ba8364d17c28300702fa130caba95bb1.png";